import { render, staticRenderFns } from "./relJinhengDialog5.vue?vue&type=template&id=a91bd9ee"
import script from "./relJinhengDialog5.vue?vue&type=script&lang=js"
export * from "./relJinhengDialog5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports